<template>
  <Teleport to="#popup-root">
    <Transition>
      <div class="popup" :class="{ fullscreen: fullscreen }" v-show="show">
        <div class="container-fluid h-100">
          <div
            class="row h-100 justify-content-center align-items-center"
            :class="{ 'gx-0': fullscreen }"
          >
            <div
              class="col-12"
              :class="{
                'col-sm-10 col-md-8 col-lg-6 col-xxl-auto': !fullscreen,
                'h-100': fullscreen,
              }"
            >
              <div class="popup-window">
                <span
                  v-if="!fullscreen"
                  class="popup-close"
                  @click="closePopup"
                ></span>
                <span v-else class="popup-close" @click="closePopup"
                  >&nbsp; Закрыть</span
                >
                <div
                  class="title title--form text-center"
                  v-if="hasSlot('popup-title')"
                >
                  <slot name="popup-title"></slot>
                </div>
                <slot name="popup-content"></slot>
              </div>
            </div>
          </div>
        </div>
      </div>
    </Transition>
  </Teleport>
</template>

<script setup lang="ts">
import { watch } from "vue";

const props = defineProps({
  show: {
    type: Boolean,
    default: false,
  },
  fullscreen: {
    type: Boolean,
    default: false,
  },
});

const emit = defineEmits(["close"]);

const closePopup = () => {
  document.body.classList.remove("popup-shown");
  emit("close");
};
watch(
  () => props.show,
  () => {
    if (props.show) {
      document.body.classList.add("popup-shown");
    } else {
      document.body.classList.remove("popup-shown");
    }
  },
);

const slots = useSlots();
const hasSlot = (name) => {
  return !!slots[name];
};
</script>

<style>
.popup-subtitle {
  margin-bottom: 24px;
  text-align: center;
}

.popup-field {
  margin-bottom: 32px;
}
</style>
<style scoped>
.v-enter-active,
.v-leave-active {
  transition: opacity 0.4s ease;
}

.v-enter-from,
.v-leave-to {
  opacity: 0;
}

.popup {
  background: rgba(0, 0, 0, 0.05);
  backdrop-filter: blur(7px);
  position: fixed;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  z-index: 1000;
  overflow: auto;
}

.popup-window {
  padding: 32px 1.6rem;
  position: relative;
  background: #fff;
  border-radius: 15px;
}

/* Высокие окна: не прилипают к краям экрана и целиком доступны при прокрутке */
.popup:not(.fullscreen) .row {
  height: auto !important;
  min-height: 100%;
}

.popup:not(.fullscreen) .popup-window {
  margin: 40px 0;
}

.popup.fullscreen .popup-window {
  padding: 0;
  border-radius: 0;
  height: 100%;
}

.popup-close {
  position: absolute;
  font-size: 16px;
  top: 16px;
  right: 16px;
  cursor: pointer;
  font-weight: 500;
  display: inline-flex;
  align-items: center;
}

.popup-close:before {
  content: "";
  position: relative;
  transition: all 0.3s ease;
  width: 17px;
  height: 17px;
  background: url("../../components/layout/img/icon-close.svg") center center /
    contain no-repeat;
}

.popup-close:hover:before {
  transform: rotate(90deg);
}

.popup.fullscreen .container-fluid {
  padding-left: 0;
  padding-right: 0;
}

@media (min-width: 1400px) {
  .popup:not(.fullscreen) .popup-window {
    width: 450px;
  }
}
</style>
